import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { PlatformDataType } from 'hooks/api/usePlatform';

export type editPlatformDataType = {
  id: string;
  errorCallback?: Function;
  resultKey?: string;
  successCallback?: Function;
  parameters: PlatformDataType;
};

export default ({
  id,
  parameters,
  successCallback,
  errorCallback,
  resultKey = 'editPlatformData',
}: editPlatformDataType) =>
  requestAsync({
    url: endpoints.getPlatformByIdUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getPlatformByIdUrl(id),
    body: parameters,
    options: {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
